export const STATE = {
  REQUESTED: 'requested',
  APPROVED: 'approved',
  DECLINED: 'declined',
}
